import { pagingSettings } from '../../../utils/GridPagingUtils';
import MyClaimsListPageActionTypes from '../actions/my-claims-list-page-action-types';

const initialState = {
  loading: false,
  claims: null,
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  cancelToken: null,
  selectedClaimId: null,
  isDeleteDialogVisible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_END:
      return {
        ...state,
        loading: false,
        claims: action.payload?.claims ?? state.claims,
        total: action.payload?.total ?? state.total,
        skip: action.payload?.skip ?? state.skip,
        take: action.payload?.take ?? state.take
      };
    case MyClaimsListPageActionTypes.SELECT_MY_CLAIM:
      return {
        ...state,
        selectedClaimId: action.payload?.selectedClaimId ?? null
      };
    case MyClaimsListPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG:
      return {
        ...state,
        isDeleteDialogVisible: !state.isDeleteDialogVisible
      };
    default:
      return state;
  }
};
